import React from 'react';
import { isLollySkin } from '@utils/index';

interface SelectPlanIconProps {
  className?: string;
  size?: number;
}

export const SelectPlanIcon: React.FC<SelectPlanIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  const strokeColor = '#e4e2dc';
  
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: ${strokeColor};
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <line className="st0" x1="23.93" y1="112.77" x2="15.06" y2="112.77"/>
      <line className="st0" x1="62.2" y1="112.77" x2="62.2" y2="112.77"/>
      <path className="st0" d="M50.01,92.7V16.14h84.93v96.63c0,11.65-9.44,21.09-21.09,21.09h0c-11.65,0-21.09-9.44-21.09-21.09h-54.17"/>
      <line className="st0" x1="106.02" y1="39.4" x2="114.34" y2="39.4"/>
      <line className="st0" x1="92.52" y1="60.33" x2="114.34" y2="60.33"/>
      <line className="st0" x1="71.43" y1="81.26" x2="114.34" y2="81.26"/>
      <polyline className="st0" points="64.99 50 75 60.33 89.46 37.51"/>
    </svg>
  );
};
